import { TopMenuItem } from "~/models/menu";
import { MegaSubMenuRow } from "./MegaSubMenuRow";

export function MegaSubMenu({ item }: { item: TopMenuItem }) {
  // split the item's children into rows of 4 items each
  const rows: TopMenuItem[][] = [];
  for (let i = 0; i < item.children!.length; i += 4) {
    rows.push(item.children!.slice(i, i + 4));
  }

  return (
    <>
      <div className="tw:w-full tw:p-4 tw:!border tw:!border-gray-500 tw:bg-white">
        {rows.map((col, index) => (
          <MegaSubMenuRow
            key={index}
            col={col}
            dir={index % 2 === 0 ? "ltr" : "rtl"}
          />
        ))}
      </div>
    </>
  );
}
